import * as yup from "yup";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type FillExcavationMaterialFormProps = {
    id: string;
    returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: FillExcavationMaterialInput;
    action: "post" | "put";
};

export type FillExcavationMaterialInput = {
    fillExcavationMaterialId: bigint;
    applicationId: number;
    applicationInspectionId: number;
    mediaLayer1ComplianceId: number;
    mediaLayer1Comment: string;
    mediaLayer2ComplianceId: number;
    mediaLayer2Comment: string;
    excavationDepthComplianceId: number;
    excavationDepthComment: string;
    bottomOfMediaLayer2: string;
    aboveBelowBenchmark: string;
    depthInFeet: number;
    lengthInFeet: number;
    widthInFeet: number;
    replacementMaterialComplianceId: number;
    replacementMaterialComment: string;
    dateCreated: Date|string;
    createdBy: string;
    dateUpdated: Date;
    updatedBy: string;
    markAll: number;
    inspectionStatusId:number;
    excavationDepthCompliance?: ComplianceOptions;
    mediaLayer1Compliance?: ComplianceOptions;
    mediaLayer2Compliance?: ComplianceOptions;
    replacementMaterialCompliance?: ComplianceOptions;

};
export type ComplianceData = {
    id: string;
    name: string;
};

export const schema = yup.object().shape({
  
    mediaLayer1ComplianceId: yup
      .number()
      .required("MediaLayer1ComplianceId is required")
      .typeError("MediaLayer1Compliance is required"),
      mediaLayer1Comment: yup.string().nullable(true)
      .when("mediaLayer1ComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Media Layer 1 Comment is required")
        .typeError("Media Layer 1 Comment is required"),
      }),
      mediaLayer2ComplianceId: yup
      .number()
      .required("MediaLayer2ComplianceId is required")
      .typeError("MediaLayer2Compliance is required"),
      mediaLayer2Comment: yup.string().nullable(true)
      .when("mediaLayer2ComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Media Layer 2 Comment is required")
        .typeError("Media Layer 2 Comment is required"),
      }),
      excavationDepthComplianceId: yup
      .number()
      .required("ExcavationDepthComplianceId is required")
      .typeError("ExcavationDepthCompliance is required"),
      excavationDepthComment: yup.string().nullable(true)
      .when("excavationDepthComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Excavation Depth Comment is required")
        .typeError("Excavation Depth Comment is required"),
      }),
      depthInFeet: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("excavationDepthComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
      .min(1, "Depth (D in feet) is required")
      .required("Depth (D in feet) is required")
      .typeError("Depth (D in feet) is required"),
      }),
      lengthInFeet: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("excavationDepthComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
      .min(1, "Length (L in feet) is required")
      .required("Length (L in feet) is required")
      .typeError("Length (L in feet) is required"),
      }),
      widthInFeet: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
      .when("excavationDepthComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then:yup.number()
      .min(1, "Width (W in feet) is required")
      .required("Width (W in feet) is required")
      .typeError("Width (W in feet) is required"),
      }),
      replacementMaterialComplianceId: yup
      .number()
      .required("ReplacementMaterialComplianceId is required")
      .typeError("ReplacementMaterialComplianceId is required"),
      replacementMaterialComment: yup.string().nullable(true)
      .when("replacementMaterialComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Replacement Material Comment is required")
        .typeError("Replacement Material Comment is required"),
      }),
      bottomOfMediaLayer2: yup.number().nullable(true).transform((value) => Number.isNaN(value)?null:value)
  .when("mediaLayer2ComplianceId", {
    is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
    then: yup.number()
      .min(1, "Media Layer 2 Bottom is required")
      .required("Media Layer 2 Bottom is required")
      .typeError("Media Layer 2 Bottom is required"),
    otherwise: yup.number().nullable().notRequired()
  }),
aboveBelowBenchmark: yup.string().nullable(true)
        .transform((value, originalValue) => {
            if (originalValue === "" || originalValue === null || originalValue === undefined) return null;
            return originalValue;
        })
        .when("mediaLayer2ComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable && val != Constants.Unobserved),
            then: yup.string()
                .nullable(true)
                .oneOf(["Above", "Below"], "Media Layer 2 Benchmark is required")
                .required("Media Layer 2 Benchmark is required")
                .typeError("Media Layer 2 Benchmark is required")
        }),
  });
